import api from '../utils/api';
import { logError } from '@zg-rentals/log-error';

const ApplicationActions = {
  enableApplications() {
    return (dispatch) =>
      dispatch(api.users.applications.enableApplications())
        .then((response = {}) => {
          if (response.success === false) {
            return Promise.reject(response.error);
          }
          return response;
        })
        .catch((err) => Promise.reject(err));
  },
  inviteToApply(body = {}) {
    return (dispatch) =>
      dispatch(api.users.applications.inviteToApply(body))
        .then((response = {}) => {
          if (response.success === false) {
            return Promise.reject(response.error);
          }
          return response;
        })
        .catch((errorRMWModel) => {
          logError({
            message: errorRMWModel,
            context: 'ApplicationActions.inviteToApply',
          });

          return Promise.reject(errorRMWModel);
        });
  },
  copyApplicationLinkApi(body = {}) {
    return (dispatch) =>
      dispatch(api.users.applications.copyApplicationLinkApi(body))
        .then((response = {}) => {
          if (response.success === false) {
            return Promise.reject(response.error);
          }
          return response;
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'ApplicationActions.inviteToApplyLink',
          });

          return Promise.reject(errorRMWModel);
        });
  },
};

export default ApplicationActions;
